export const ProtectedRoute = ({
  children,
  allowed,
}: {
  children: React.ReactNode;
  allowed: boolean;
}) => {
  if (!allowed) {
    return (
      <div
        style={{
          fontWeight: 'bold',
          width: '100%',
          textAlign: 'center',
          margin: '32px 0',
        }}
      >
        You do not have permission to this feature.
      </div>
    );
  }
  return <>{children}</>;
};
